import React from 'react';
import { Chip } from '@mui/material';
import { toneFor } from '../../theme/statusTones';

/**
 * The one status label: a solid chip with white text, coloured from
 * theme/statusTones.js. `kind` is which status vocabulary `status` belongs to —
 * application, contract, user or registration — since "draft" or "approved"
 * mean different things to each. `label` is the page's own wording; the chip
 * only decides the colour.
 */
const StatusLabel = ({ kind = 'application', status, label, size = 'medium', sx = {} }) => {
  const tone = toneFor(kind, status);
  const small = size === 'small';
  return (
    <Chip
      label={label || String(status || '-').replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())}
      size="small"
      sx={{
        backgroundColor: tone.bg,
        color: tone.color,
        fontWeight: 600,
        fontSize: small ? '11px' : '12px',
        height: small ? 22 : 24,
        borderRadius: '12px',
        '& .MuiChip-label': { padding: '0 10px' },
        ...sx,
      }}
    />
  );
};

export default StatusLabel;
